import React from "react";
import { Link } from "react-router-dom";

function Header() {


    function showsidebar() {
        const sidebar = document.querySelector('.sidebar');
        sidebar.style.display = 'flex'
    }

    function hidesidebar() {
        const hidebar = document.querySelector('.sidebar')
        hidebar.style.display = 'none'
    }

    return (

        <header>
            <div className="cont">
                <p className="mob">Mobile: +91 9167862525</p>
                <p className="em">E-mail: <a href="mailto:" className="anc">sales@hexatechseal.com</a></p>
                {/* <a href="" onClick={showsidebar}><i className="fa-solid fa-bars ico dis" /></a> */}
                {/* <i className="fa-solid fa-bars ico dis" onClick={showsidebar}></i> */}
                <i className="fa-solid fa-bars ico" onClick={showsidebar}></i>
            </div>

            <hr id="cont-line" />

            <nav>

                <div className="top">

                    <img src="./images/logo.png" alt="Logo" className="logo" />

                    <div className="nav-btn">
                        <Link to="/" id="kl"><a className="h">home</a></Link>
                        <Link to="/about" id="kl"><a className="h">about</a></Link>
                        <Link to="/product" id="kl"><a className="h">products</a></Link>
                        <Link to="/video" id="kl"><a href="#" className="h">videos</a></Link>
                        <Link to="/contactus" id="kl"> <a href="#" className="h">contact</a></Link>
                        <a href="#" onClick={showsidebar} className="mn"><i className="fa-solid fa-bars ico" /></a>
                    </div>

                </div>

                <div className="sidebar">

                    <a href="#" onClick={hidesidebar}><i className="fa-solid fa-x x" /></a>
                    <Link to='/' id="ij"><a className="h g">home</a></Link>
                    <Link to='/about' id="ij"><a href="#" className="h g">about</a></Link>
                    <Link to='/product' id="ij"><a href="#" className="h g">products</a></Link>
                    <Link to='/video' id="ij"><a href="#" className="h g">videos</a></Link>
                    <Link to='/contactus' id="ij"><a href="#" className="h g">contact</a></Link>

                </div>

            </nav>
            
        </header>

    );

};

export default Header

